<form (ngSubmit)="save()" [formGroup]="form" novalidate class="flex flex-column">
    <div class="grid">
        <div class="col">

            <!-- Logo -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label>Logo</label>
                </div>
                <div class="col-8 flex">
                    <div class="col-6">
                        @if (!!client.logo) {
                        <div>
                            <p-image [src]="client.logo" alt="Logo" width="100%"></p-image>
                        </div>
                        } @else {
                        <div class="flex align-items-center justify-content-center surface-200 border-round-lg"
                            style="width: 150px; height: 150px;">
                            <i class="pi pi-image text-6xl text-gray-400"></i>
                        </div>
                        }
                    </div>
                    <div class="col-6 flex align-items-center justify-content-end">
                        @if (appService.user?.hasAuthorization(Authorizations.ClientUpdate)) {
                        <p-fileUpload #fuLogo mode="basic" accept="image/png,image/jpeg" chooseLabel="Changer logo"
                            chooseIcon="pi pi-image" styleClass="p-button-rounded" maxFileSize="5242880"
                            invalidFileSizeMessageSummary="Image trop volumineuse"
                            invalidFileSizeMessageDetail="La taille de l'image ne doit pas dépasser 5 Mo"
                            invalidFileTypeMessageSummary="Type de fichier invalide"
                            invalidFileTypeMessageDetail="Seuls les fichiers de type PNG et JPG sont autorisés"
                            [auto]="true" [customUpload]="true" [disabled]="clientService.uploading$ | async"
                            (uploadHandler)="onUpload($event);fuLogo.clear()"></p-fileUpload>
                        }
                    </div>
                </div>
            </div>

            <!-- Info Logo -->
            <div class="flex align-items-center">
                <div class="col-4"></div>
                <div class="col-8">
                    <small class="text-color-secondary">Le logo apparaîtra sur les factures et documents. Il doit
                        idéalement être au format PNG avec un fond transparent, si sa dimension maximale dépasse 600px,
                        il sera redimensionné.</small>
                </div>
            </div>

            <!-- Avatar -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label>Avatar</label>
                </div>
                <div class="col-4 flex justify-content-start">
                    <div class="w-5rem h-5rem border-circle border-0 overflow-hidden shadow-1">
                        @if (!!client) {
                        <p-image [src]="client.avatar || 'https://placehold.co/300/E2E8F0/9CA3AF'" alt="Avatar"
                            height="60"></p-image>
                        }
                    </div>
                </div>
                <div class="col-4 flex align-items-center justify-content-end">
                    @if (appService.user?.hasAuthorization(Authorizations.ClientUpdate)) {
                    <p-fileUpload #fuAvatar mode="basic" accept="image/png,image/jpeg" chooseLabel="Changer avatar"
                        chooseIcon="pi pi-user" styleClass="p-button-rounded" maxFileSize="5242880"
                        invalidFileSizeMessageSummary="Image trop volumineuse"
                        invalidFileSizeMessageDetail="La taille de l'image ne doit pas dépasser 5 Mo"
                        invalidFileTypeMessageSummary="Type de fichier invalide"
                        invalidFileTypeMessageDetail="Seuls les fichiers de type PNG et JPG sont autorisés"
                        [auto]="true" [customUpload]="true" [disabled]="clientService.uploading$ | async"
                        (uploadHandler)="onUploadAvatar($event);fuAvatar.clear()"></p-fileUpload>
                    }
                </div>
            </div>

            <!-- Info Avatar -->
            <div class="flex align-items-center">
                <div class="col-4"></div>
                <div class="col-8">
                    <small class="text-color-secondary">L'avatar sera utilisé dans l'application, affiché sous forme de
                        rond. L'image doit idéalement être carrée et sera redimensionnée en 300x300 px.</small>
                </div>
            </div>

            <!-- Nom du client -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-name" class="block">Raison sociale</label>
                </div>
                <div class="col-8">
                    <input id="input-name" type="text" pInputText formControlName="name" placeholder="Raison sociale"
                        required />
                </div>
            </div>

            <!--  Nom commercial -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-commercialName" class="block">Nom commercial</label>
                </div>
                <div class="col-8">
                    <input id="input-commercialName" type="text" pInputText formControlName="commercialName"
                        placeholder="Nom" required />
                </div>
            </div>

            <!--  Forme juridique -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-legalStatus" class="block">Forme juridique</label>
                </div>
                <div class="col-8">
                    <p-select [options]="legalStatuses" formControlName="legalStatus" filterBy="label"
                        placeholder="Forme juridique">
                        <ng-template let-legalStatus #selectedItem>
                            @if (!!legalStatus) {
                            <span>{{legalStatus.label}}</span>
                            }
                        </ng-template>
                        <ng-template let-legalStatus #item>
                            <span>{{legalStatus.label}}</span>
                        </ng-template>
                    </p-select>
                </div>
            </div>

            <!-- Capital social -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-shareCapital" class="block">Capital social</label>
                </div>
                <div class="col-8">
                    <p-inputgroup>
                        <p-inputNumber inputId="input-shareCapital" mode="decimal" [min]="0"
                            formControlName="shareCapital" [inputStyle]="{'width': '100%'}"
                            [minFractionDigits]="client.currency.decimalPlaces || 0"></p-inputNumber>

                        <p-inputgroup-addon>
                            {{ client.currency.code }}
                        </p-inputgroup-addon>
                    </p-inputgroup>
                </div>
            </div>

            <!-- Activité principale -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-activity" class="block">Activité principale</label>
                </div>
                <div class="col-8">
                    <p-select [options]="mainActivities" formControlName="mainActivity" filterBy="label"
                        placeholder="Activité principale">
                        <ng-template let-item #selectedItem>
                            <span>{{item?.label || ''}}</span>
                        </ng-template>
                        <ng-template let-item #item>
                            <span>{{item.label}}</span>
                        </ng-template>
                    </p-select>
                </div>
            </div>

            <!-- Contexte métier -->
            <div class="flex align-items-start">
                <div class="col-4 flex align-items-center justify-content-between">
                    <label class="block">Dites-nous en plus sur vous</label>
                    <p-button icon="pi pi-info-circle" type="button" [rounded]="true" [text]="true"
                        (click)="opBusinessContext.toggle($event)"></p-button>
                </div>
                <div class="col-8">
                    <textarea pTextarea formControlName="businessContext" [rows]="4" class="w-full"
                        placeholder="Décrivez votre activité, vos clients, vos fournisseurs, vos particularités…"></textarea>
                </div>
            </div>

            <!-- Taille -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label for="input-size" class="block">Taille</label>
                </div>
                <div class="col-8">
                    <p-select [options]="sizes" formControlName="size" filterBy="label"
                        placeholder="Taille de l'entreprise">
                        <ng-template let-item pTemplate="selectedItem">
                            <span>{{item?.label || ''}}</span>
                        </ng-template>
                        <ng-template let-item pTemplate="item">
                            <span>{{item.label}}</span>
                        </ng-template>
                    </p-select>
                </div>
            </div>

            <!-- Fuseau horaire -->
            <div class="flex align-items-center">
                <div class="col-4">
                    <label class="block">Fuseau horaire</label>
                </div>
                <div class="col-8">
                    <p-select [options]="timezones" formControlName="timezone" [filter]="true" filterBy="label"
                        placeholder="Fuseau horaire">
                        <ng-template let-item pTemplate="selectedItem">
                            <span>{{item?.label || ''}}</span>
                        </ng-template>
                        <ng-template let-item pTemplate="item">
                            <span>{{item.label}}</span>
                        </ng-template>
                    </p-select>
                </div>
            </div>

            <!-- Sauvegarde -->
            <div class="flex align-items-center">
                <div class="col-12 flex justify-content-end">
                    <p-button type="submit" label="Sauvegarder" [rounded]="true" [disabled]="!canSave()"
                        [loading]="clientService.updating$ | async"></p-button>
                </div>
            </div>
        </div>
    </div>
</form>

<p-popover #opBusinessContext>
    <div class="w-25rem">
        <p>
            Plus vous nous en dites sur votre société (activité, clients, fournisseurs, particularités…), plus la
            comptabilisation automatique de vos factures sera fiable.
        </p>
    </div>
</p-popover>